/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { durationStep, durations } from '../utils/durations';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { exitingDurations } from '../utils/exiting-durations';

/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { Durations } from '../utils/durations';
